var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7778 0H3.22222C1.45 0 0.0161111 1.45 0.0161111 3.22222L0 25.7778C0 27.55 1.45 29 3.22222 29H25.7778C27.55 29 29 27.55 29 25.7778V3.22222C29 1.45 27.55 0 25.7778 0ZM24.1667 17.7222H17.7222V24.1667H11.2778V17.7222H4.83333V11.2778H11.2778V4.83333H17.7222V11.2778H24.1667V17.7222Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescriptionIcon.26c35bbaf2268c7f23418aa4e009654f.svg";
export { ForwardRef as ReactComponent };